import "./stat.scss";

import classNames from "classnames";

type StatProps = {
	label: string;
	value: string | number;

	changeType?: "increase" | "decrease" | "no-change";
	showChangeArrow?: boolean;
};

const Stat: React.FC<StatProps> = (props) => {
	const {
		label,
		value,
		changeType = "no-change",
		showChangeArrow = false,
	} = props;
	return (
		<div className="stat-wrapper">
			<div
				className={classNames("stat-value", {
					increase: changeType === "increase",
					decrease: changeType === "decrease",
					"no-change": changeType === "no-change",
				})}
			>
				{showChangeArrow && changeType === "increase" && (
					<span className="arrow-up">▲ </span>
				)}
				{showChangeArrow && changeType === "decrease" && (
					<span className="arrow-down">▼ </span>
				)}
				<div className="stat-value-v">{value}</div>
			</div>
			<div className="stat-label">{label}</div>
		</div>
	);
};

export default Stat;
